module.exports = __webpack_public_path__ + "static/illustration-requirements-et@2x-c0849fe6e83304d2193371d7fe471606.png";